module.exports = __webpack_public_path__ + "img/24_hr_emergency_assistance.3e1bc946.png";